<div class="custom-center" style="height: 100vh; width: 100vw; flex-direction: column;">
    <h1>Bienvenido al sistema de permisos de trabajo</h1>
    <h4>Aquí podrá cambiar su contraseña. Recuerde que la misma no debe ser idéntica a la anterior</h4>
    <div class="mt-4 p-5 shadow" style="background: white; border-radius: 12px;">
        <app-input-password #p1 (valid)="isValid = $event" />
        <div class="mt-3">
            <app-input-password [onlyPass]="true" #p2 />
            <div class="hide-container" [ngClass]="{ 'show-container': error }">
                <div>
                    <p class="text-danger">{{ message }} *</p>
                </div>
            </div>
        </div>

        <div class="mt-3 flex justify-content-between">
            <button class="btn btn-danger" (click)="logout()">Salir</button>
            <button class="btn btn-primary" (click)="changePass(p1.value, p2.value)">Cambiar</button>
        </div>
    </div>
</div>

<app-dialog #dialog />